import { render, staticRenderFns } from "./TakeTest.vue?vue&type=template&id=25473898&"
import script from "./TakeTest.vue?vue&type=script&lang=js&"
export * from "./TakeTest.vue?vue&type=script&lang=js&"
import style0 from "./TakeTest.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports